<template>
  <div @click="$store.commit('progress')" class="center-middle" style="background-color:rgba(0,0,0,.1);z-index:1051">
    <!-- <div style="background-color:var(--kt-card-bg);width:150px;padding:10px 15px 15px;text-align:center;border-radius:5px">
      <small v-text="text" />
      <b-progress class="mt-2" :value="value" animated :show-progress="value!=99" striped />
    </div> -->
    <div>
      <b-spinner variant="primary" key="primary" style="width: 3rem; height: 3rem; border-width: 0.3rem !important;"></b-spinner>
    </div>
  </div>
</template>

<script>
export default {
  props: ['text', 'value'],
}
</script>